export class RouteValues {

  public text: string;
  public value: number;

}
